'use strict';

var prefix = '@@reactReduxFirebase/';

module.exports = {
    SET: prefix + 'SET',
    SET_PROFILE: prefix + 'SET_PROFILE',
    LOGIN: prefix + 'LOGIN',
    LOGOUT: prefix + 'LOGOUT',
    LOGIN_ERROR: prefix + 'LOGIN_ERROR',
    //  NO_VALUE: `${prefix}NO_VALUE`,
    START: prefix + 'START',
    INIT_BY_PATH: prefix + 'INIT_BY_PATH'
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-react-firebase/build/constants.js
// module id = 306
// module chunks = 0